import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: 'system',
    colorScheme: 'pink'
  }),

  actions: {
    setTheme(theme) {
      this.theme = theme
      
      if (theme === 'system') {
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
        document.documentElement.classList.remove('light', 'dark')
        document.documentElement.classList.add(systemTheme)
      } else {
        document.documentElement.classList.remove('light', 'dark')
        document.documentElement.classList.add(theme)
      }
      
      localStorage.setItem('theme', theme)
    },

    setColorScheme(scheme) {
      this.colorScheme = scheme
      localStorage.setItem('colorScheme', scheme)
    },

    initTheme() {
      // Check local storage or default to system
      const savedTheme = localStorage.getItem('theme') || 'system'
      this.setTheme(savedTheme)
      
      // Listen for system theme changes
      if (savedTheme === 'system') {
        window.matchMedia('(prefers-color-scheme: dark)')
          .addEventListener('change', e => {
            if (this.theme === 'system') {
              document.documentElement.classList.remove('light', 'dark')
              document.documentElement.classList.add(e.matches ? 'dark' : 'light')
            }
          })
      }
      
      const savedColorScheme = localStorage.getItem('colorScheme')
      if (savedColorScheme) {
        this.setColorScheme(savedColorScheme)
      }
    }
  }
}) 